import { RouterProvider } from "react-router-dom";
import { router } from "./AppRoutes";
import HeaderComponent from "./Components/HeaderComponent";
import { useHeader } from "./Providers/HeaderContextProvider";
import { Toaster } from "react-hot-toast";

function Layout() {
  const { headerContent, headerContentRightSideContent, profileContent, isCoachingActive } =
    useHeader();

  return (
    <>
      {headerContent && (
        <HeaderComponent
          headerContentRightSideContent={headerContentRightSideContent}
          profileContent={profileContent}
          isCoachingActive={isCoachingActive}
        />
      )}
      <RouterProvider router={router} />
      <Toaster
        position={"bottom-center"}
        toastOptions={{
          duration: 3000,
        }}
        containerStyle={{ zIndex: "99" }}
      />
    </>
  );
}

export default Layout;
